<template>
  <div id="navbar" class="black-outset d-flex align-items-center">
    <div class="w-100 h-100">
      <base-nav :data="base" :active="type" />
      <sections-nav :data="sections"/>
    </div>
  </div>
</template>
<script>
import BaseNav from '../../components/navs/BaseNav'
import SectionsNav from '../../components/navs/SectionsNav'
import store from '../../store/index'
export default {
  name: 'Navbar',
  components: { BaseNav, SectionsNav },
  props: {
    data: {
      type: Number
    }
  },
  data () {
    return {
      type: 0,
      base: [{
        text: {
          en: 'Personal',
          ar: 'الشخصية'
        },
        path: '/home'
      }
      //   {
      //   text: {
      //     en: 'Business',
      //     ar: 'الأعمال'
      //   },
      //   path: '/business'
      // }, {
      //   text: {
      //     en: 'E-Payment',
      //     ar: 'الدفع الالكتروني'
      //   },
      //   path: '/payment'
      // }, {
      //   text: {
      //     en: 'MTN World',
      //     ar: '  MTN عالم'
      //   },
      //   path: '/mtn-World'
      // }
      ],
      sections: { items: this.$t('navbar.sectionNavbar'), paths: ['/home', '/products', '/bundles', '/offers', '/roaming'] }
    }
  },
  created () {
    store.commit('user/fetchSession')
    this.type = this.data
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
#navbar {
  position: fixed;
  width: 100%;
  //height: 65px;
  z-index: 100000;
  //background: rgba(212, 212, 212, 0.45);
  background: rgba(242, 242, 242, 0.9);
  //box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(40px);
}

</style>
